<template id="grid-template">
  <div v-show="getAuthWithRouter" class="background">
    <Header />

    <div class="filter-content">
      <v-container fluid>
        <v-layout wrap>
          <v-flex xs3 class="quantity-content">
            <strong class="quantity">{{
              getSales.length > 0 ? getSales.length : 0
            }}</strong>
            <br />Ventas
          </v-flex>
          <v-flex xs9 class="filter-content">
            <b-form-select
              class="filter"
              v-model="selectedStatus"
              :options="getStatus()"
            ></b-form-select>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <div class="white">.</div>

    <table>
      <thead>
        <tr>
          <td class="sale">Nro. Venta</td>
          <td class="customerName">Nombre del cliente</td>
          <td class="customerAdress">Dirección del cliente</td>
          <td class="status">Estado</td>
          <td>Total</td>
          <td class="date">Fecha</td>
          <td class="actions">Acciones</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="sale in getSales" :key="sale.saleNumber">
          <td>{{ sale.saleNumber }}</td>
          <td>{{ sale.customerName }}</td>
          <td>{{ sale.customerAdress }}</td>
          <td v-if="sale.status === 'Finalizada'" style="color: green">
            {{ sale.status }}
          </td>
          <td v-else-if="sale.status === 'Anulada'" style="color: red">
            {{ sale.status }}
          </td>
          <td v-else style="color: #a6a600">{{ sale.status }}</td>
          <td>$ {{ sale.total }}</td>
          <td>{{ sale.date }}</td>
          <td class="actions-img">
            <img
              v-if="sale.status === 'Para Entregar'"
              class="button-img"
              alt="Editar"
              title="Editar"
              @click.prevent="openEditSale(sale)"
              src="../assets/edit.svg"
            />
            <img
              class="button-img"
              alt="Ver"
              title="Ver"
              @click.prevent="openSearchSale(sale)"
              src="../assets/search.svg"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <ModalTracking v-if="showModal" :sale="sale" @close="onCloseModal" />
    <ModalEditTracking
      v-if="showEditModal"
      :sale="sale"
      :status="status"
      @editSale="onEditSale"
      @close="onCloseModal"
    />
  </div>
</template>

<script>
import ModalTracking from "../components/ModalTracking";
import ModalEditTracking from "../components/ModalEditTracking";
import Header from "../components/Header";
import { db } from "../firebase";
import firebase from "firebase/firebase";
import "firebase/auth";
import user_detection from "../mixins/user_detection";

export default {
  mixins: [user_detection],
  name: "Tracking",
  firebase: {
    sales: db.ref("sales"),
    status: db.ref("status"),
  },
  data() {
    return {
      sales: [],
      status: [],
      selectedStatus: "Filtrar por estado",
      showModal: false,
      showEditModal: false,
      sale: {},
    };
  },
  mounted() {
    this.isUserAdmin();
  },
  computed: {
    getSales() {
      if (this.selectedStatus == "Filtrar por estado") {
        return this.sales;
      } else {
        var array = [];

        this.sales.forEach((sale) => {
          if (sale.status == this.selectedStatus) {
            array.push(sale);
          }
        });

        return array;
      }
    },
  },
  methods: {
    onEditSale(sale) {
      if (sale.status !== "Para Entregar") {
        if (sale.status === "Anulada") {
          sale.products.forEach((p) => {
            db.ref("products").once("value", function (snapshot) {
              snapshot.forEach(function (childSnapshot) {
                var childKey = childSnapshot.key;
                var prod = childSnapshot.val();
                if (prod.code === p.code) {
                  prod.stock = parseInt(p.quantity) + parseInt(prod.stock);
                  db.ref("products/" + childKey).update(prod);
                }
              });
            });
          });
        }
        db.ref("sales/" + sale[".key"]).update(sale);
      }

      this.showEditModal = false;
    },
    openEditSale(sale) {
      this.sale = sale;
      this.showEditModal = true;
    },
    openSearchSale(sale) {
      this.sale = sale;
      this.showModal = true;
    },
    onCloseModal() {
      this.showModal = false;
      this.showEditModal = false;
      this.sale = {};
    },
    getStatus() {
      var array = [];
      array.push("Filtrar por estado");
      for (var i = 0; i < this.status.length; i++) {
        array.push(this.status[i].name);
      }
      return array;
    },
    onFinish(saleNumber) {
      db.ref("sales")
        .orderByChild("status")
        .equalTo("Para Entregar")
        .once("value", function (snapshot) {
          snapshot.forEach(function (childSnapshot) {
            var childKey = childSnapshot.key;
            var sale = childSnapshot.val();
            if (sale.saleNumber == saleNumber) {
              var option = confirm(
                "Esta seguro que desea finalizar la venta número '" +
                  saleNumber +
                  "'?"
              );
              if (option == true) {
                sale.status = "Finalizada";
                db.ref("sales/" + childKey).update(sale);
              }
            }
          });
        });
    },
  },
  components: {
    ModalTracking,
    ModalEditTracking,
    Header,
  },
};
</script>
<style scoped>
/* .background {
  background: #e9ecef;
} */

body {
  font-family: Helvetica Neue, Arial, sans-serif;
  font-size: 14px;
  color: #444;
}

.button-img {
  height: auto;
  width: auto;
  max-width: 40px;
  max-height: 40px;
  padding: 10px;
}
.actions-img {
  text-align: right;
}

table {
  border: 3px solid #e9ecef;
  margin-top: 15px;
  margin-bottom: 15px;
  border-radius: 3px;
  background-color: #fff;
  margin-left: 2%;
  margin-right: 2%;
}

th {
  /* background-color: #007bff; */
  color: rgba(255, 255, 255, 0.66);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
thead {
  background: #e9ecef;
}

tbody td {
  background-color: #f9f9f9;
}

th,
td {
  min-width: 120px;
  padding: 12px 25px;
  text-align: center;
}

tr {
  border: 3px solid #e9ecef;
}

.customerName {
  width: 300px;
}

.customerAdress {
  width: 500px;
}

.sale {
  width: 130px;
}

.date {
  width: 225px;
}
.status {
  width: 170px;
}

.actions {
  width: 150px;
}

.quantity {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.quantity-content {
  align-self: center;
  text-align: center;
}

.filter-content {
  background: #e9ecef;
  align-self: center;
  /* margin-top: -20px; */
}
.filter {
  /* margin-top: 5px; */
  width: 40%;
}
.white {
  background: white;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/views/Tracking.vue